const storeIsExistingFirebaseUserInLocalStorage = (isExistingFirebaseUser) => {
  localStorage.setItem('anova_is_existing_firebase_user', JSON.stringify(isExistingFirebaseUser))
}

export default storeIsExistingFirebaseUserInLocalStorage
